import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type GrantableUsersSearchFailedAction = {
	type: 'GRANTABLE_USERS_SEARCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): GrantableUsersSearchFailedAction => ({
	type: 'GRANTABLE_USERS_SEARCH_FAILED',
	payload,
});
